export function normalizeHex(hex) {
    if (!hex) return null;
    let v = String(hex).trim();
    if (!v.startsWith('#')) v = `#${v}`;
    if (v.length === 4) {
        const r = v[1], g = v[2], b = v[3];
        v = `#FF${r}${r}${g}${g}${b}${b}`;
    } else if (v.length === 7) {
        v = `#FF${v.slice(1)}`;
    }
    if (!/^#([A-Fa-f0-9]{8})$/.test(v)) return null;
    return v.toUpperCase();
}

export function hexToRgba(hexAARRGGBB) {
    const v = normalizeHex(hexAARRGGBB);
    if (!v) return null;
    const a = parseInt(v.slice(1, 3), 16) / 255;
    const r = parseInt(v.slice(3, 5), 16);
    const g = parseInt(v.slice(5, 7), 16);
    const b = parseInt(v.slice(7, 9), 16);
    return { r, g, b, a, css: `rgba(${r}, ${g}, ${b}, ${a.toFixed(3)})` };
}

export function getContrastTextColor(hex) {
    const v = normalizeHex(hex) || '#FF111827';
    const r = parseInt(v.slice(3, 5), 16) / 255;
    const g = parseInt(v.slice(5, 7), 16) / 255;
    const b = parseInt(v.slice(7, 9), 16) / 255;
    const toLin = (c) => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));
    const L = 0.2126 * toLin(r) + 0.7152 * toLin(g) + 0.0722 * toLin(b);
    return L > 0.5 ? '#111' : '#FFF';
}
